<script lang="ts">
	import type { RouteType } from './types';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import * as c from '$lib/i18n/computedMessages';

	export let type: RouteType;
	export let isSelected = true;

	const mappingIcon = {
		quickest: 'sprint',
		economic: 'savings',
		ecological: 'eco',
		alternative: 'ramp-right',
		shortest: 'ruler',
		discovery: 'scenic-road',
	};
</script>

<div>
	<Badge
		text={c.routeBadge(type)}
		isSquare
		icon={mappingIcon[type]}
		color={isSelected ? type : 'ghost'}
		class="gap-1"
	/>
</div>
